export const AUTH_ACTIONS = {
  SHOW_CONTENT: 'content',
  SHOW_MODAL: 'modal',
  SHOW_NOTHING: 'nothing',
};

export const WHITE_LIST_PAGES = ['list', 'list/new', 'preferences'];
